/* istanbul ignore file */
export enum SHARE {
    /**
     * @value Copy link from %TIME%
     */
    COPY_LINK_FROM = 'FRONT.SHARE.COPY_LINK_FROM',
    /**
     * @value Write a message...
     */
    MESSAGE_PLACEHOLDER = 'FRONT.SHARE_POSTS_TEAMS.DIALOG.MESSAGE.PLACEHOLDER',
}
